export default __webpack_public_path__ + "static/media/screen2.a4f9e73b.png";